import { toRaw } from "vue";
import { toRowAcquisitionBook } from "@/composables/reportSteppers/sampleRowUtils";

const EMBEDDED_BOOK_KEYS = new Set([
  "samplingRecordBook",
  "speedRecordBook",
  "humidityRecordBook",
  "acquisitionRecordBook",
]);

const toBookStub = (book) => {
  if (!book) return book;
  const stub = { uuid: book.uuid, label: book.label };
  if (book.matchDeltaMinutes !== undefined)
    stub.matchDeltaMinutes = book.matchDeltaMinutes;
  return stub;
};

export const toReportFormPayload = (value) => {
  value = toRaw(value);
  if (Array.isArray(value)) return value.map(toReportFormPayload);
  if (!value || typeof value !== "object" || value instanceof Date)
    return value;
  return Object.fromEntries(
    Object.entries(value).map(([key, item]) => [
      key,
      EMBEDDED_BOOK_KEYS.has(key)
        ? toBookStub(toRaw(item))
        : toReportFormPayload(item),
    ])
  );
};

export const buildBookIndex = (books) =>
  new Map(books.map((book) => [book.uuid, book]));

const hydrateBook = (key, stub, bookIndex) => {
  const book = stub?.uuid && bookIndex.get(stub.uuid);
  if (!book) return stub;
  const hydrated =
    key === "acquisitionRecordBook" ? toRowAcquisitionBook(book) : book;
  if (stub.matchDeltaMinutes === undefined) return hydrated;
  return { ...hydrated, matchDeltaMinutes: stub.matchDeltaMinutes };
};

const hydrateEmbeddedBooks = (item, bookIndex) => {
  const hydrated = { ...item };
  for (const key of EMBEDDED_BOOK_KEYS) {
    if (key in hydrated)
      hydrated[key] = hydrateBook(key, hydrated[key], bookIndex);
  }
  return hydrated;
};

export const hydrateParameterForm = (parameterForm, bookIndex) => {
  const hydrated = hydrateEmbeddedBooks(parameterForm, bookIndex);
  if (Array.isArray(hydrated.selectedSample)) {
    hydrated.selectedSample = hydrated.selectedSample.map((row) =>
      hydrateEmbeddedBooks(row, bookIndex)
    );
  }
  return hydrated;
};
